<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div *ngIf="showEmptyDimensionWarning()" role="alert" class="p-messages p-component p-mb-4">
      <div role="alert" class="p-message p-message-warn">
        <div class="p-message-wrapper">
          <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
          <span class="p-message-detail">{{ t('common.messages.empty_dimension_no_access') }}</span>
        </div>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')"></app-form-control>
        <app-form-control [cid]="'dimensions'" [control]="form.get('dimensions')" [type]="'multiselect'" [label]="t('common.labels.dimensions')" [options]="dimensionOptions" [optionLabel]="'label'" [dataKey]="'key'" [showClear]="true"></app-form-control>
        <app-form-control [cid]="'active'" [control]="form.get('active')" [type]="'checkbox'" [label]="t('common.labels.active')"></app-form-control>

      </div>
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'title_de'" [control]="form.get('title_de')" [type]="'input'" [label]="t('common.labels.title') + ' (DE)'"></app-form-control>
        <app-form-control [cid]="'title_en'" [control]="form.get('title_en')" [type]="'input'" [label]="t('common.labels.title') + ' (EN)'"></app-form-control>
        <app-form-control [cid]="'description'" [control]="form.get('description')" [type]="'textarea'" [label]="t('common.labels.description')"></app-form-control>

      </div>
    </div>

  </form>
</ng-container>
